import { render, staticRenderFns } from "./DashboardViewResponseTime.vue?vue&type=template&id=364f3eaa"
import script from "./DashboardViewResponseTime.vue?vue&type=script&lang=js"
export * from "./DashboardViewResponseTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports